module.exports = __webpack_public_path__ + "static/media/pinaza_2.5a3682af.gif";